(function () {
    'use strict';

    $.extend(ko, {

        /**
         * Creates an observable property for an object, with an optional default value.
         * @param object {Object} Target object
         * @param prop {String} Property name
         * @param [defaultValue] {*} Default value
         * @static
         *
         * @example
         *
         * var person = {};
         *
         * ko.createProperty(person, 'firstName', '');
         *
         */
        createProperty: function (object, propertyName, defaultValue) {
            var value = object[propertyName];
            if (value === undefined) {
                if (defaultValue === 0) {
                    value = defaultValue;
                }
                else {
                    value = defaultValue || null;
                }
            }
            if (!ko.isObservable(value)) {
                value = ko.observable(value);
            }

            if (typeof object.onPropertyChanging == "function") {
                var valueWillMutate = value.valueWillMutate;
                value.valueWillMutate = function(){
                    valueWillMutate();
                    object.onPropertyChanging(propertyName);
                }
            }

            if (typeof object.onPropertyChanged == "function") {
                var valueHasMutated = value.valueHasMutated;
                value.valueHasMutated = function(){
                    valueHasMutated();
                    object.onPropertyChanged(propertyName);
                }
            }

            return object[propertyName] = value;
        },


        /**
         * Returns the value of an observable or the value itself if the passed parameter is not an observable.
         * Shorthand for <code>ko.utils.unwrapObservable</code>.
         * @method
         * @static
         */
        valueOf: ko.utils.unwrapObservable,

        /*
         * Checks whether the provided value is an observable. If the value is an observable,
         * it subscribes to change notifications and retunrs the subscription.
         */
        subscribeIf: function (value, callback, target, event) {
            if (ko.isObservable(value)) {
                return value.subscribe(callback, target, event);
            }
        }
    });

    var ko_isDifferent = ko.subscribable['fn'].isDifferent;
    ko.subscribable['fn'].isDifferent = function (oldValue, newValue) {
        //same reference
        if (oldValue === newValue) {
            return false;
        }
        //same date
        if(oldValue && oldValue.getTime && newValue && newValue.getTime && oldValue.getTime() ==newValue.getTime()) {
            return false;
        }
        return ko_isDifferent.call(this, oldValue, newValue);
    }
})();
